import { ShieldCheck } from "lucide-react";

export const RstScoreBadge = ({ score = 0, tier = "Nouveau", size = "sm", light = false }) => {
  const pad = size === "sm" ? "px-2.5 py-1 text-xs" : "px-3 py-1.5 text-sm";
  const iconSize = size === "sm" ? 14 : 16;
  const cls = light ? "bg-white/15 text-white" : "bg-secondary/10 text-secondary";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold ${cls} ${pad}`}
      data-testid="rst-score-badge"
    >
      <ShieldCheck style={{ width: iconSize, height: iconSize }} />
      {tier} · {score}
    </span>
  );
};
